
/**
 * Компонент с примитивными фильтрами расположенными на красной плашке
 */

export default {
  name: 'FilterRowWrapper',
}
